import React from "react";
import {
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

export default function PrivacyView() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper elevation={0} sx={{ p: { xs: 2, sm: 4 } }}>
        <Typography
          variant="h4"
          color="text.secondary"
          align="center"
          fontWeight="bold"
          gutterBottom
        >
          时空笔记隐私政策
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          <strong>生效日期：2025年11月24日</strong>
          <br />
          <strong>开发者：于静云</strong>
        </Typography>

        <Typography paragraph>
          感谢您选择使用“时空笔记”（以下简称“本应用”或“我们”）。我们深知个人信息对您的重要性，并致力于保护您的隐私安全。本隐私声明将详细说明我们在您使用本应用过程中如何收集、使用、存储、共享和保护您的个人信息，以及您享有的相关权利。
        </Typography>

        <Typography paragraph>
          请您在使用本应用前，务必仔细阅读并充分理解本声明的全部内容。如您同意本声明，请在首次启动时点击“同意”；如您不同意，请立即停止使用本应用。
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          一、我们如何收集和使用您的个人信息
        </Typography>
        <Typography paragraph>
          为实现本应用的核心功能，我们需要在必要范围内收集以下信息：
        </Typography>

        <List dense>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={<strong>位置信息（GPS 轨迹）</strong>}
              secondary={
                <>
                  - <strong>目的</strong>：用于记录您的移动轨迹，并在地图上重现路径。
                  <br />- <strong>类型</strong>：精确地理位置（经纬度）、时间戳、移动速度。
                  <br />- <strong>方式</strong>
                  ：仅在您主动开启“轨迹记录”功能时，通过系统定位服务持续获取。
                  <br />- <strong>存储</strong>：轨迹数据保存在您设备本地。
                </>
              }
            />
          </ListItem>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={<strong>照片与视频</strong>}
              secondary={
                <>
                  - <strong>目的</strong>
                  ：支持您拍摄照片或录制视频，并将其与地理位置关联，在地图上可视化展示。
                  <br />- <strong>类型</strong>：图像/视频文件及其 EXIF 元数据（含地理位置等）。
                  <br />- <strong>注意</strong>：所有媒体仅存于本地。
                </>
              }
            />
          </ListItem>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={<strong>设备与系统信息</strong>}
              secondary={
                <>
                  - <strong>目的</strong>：保障应用正常运行、诊断问题。
                  <br />- <strong>类型</strong>：设备型号、操作系统版本、OAID（非 IMEI）等。
                </>
              }
            />
          </ListItem>
        </List>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          二、权限申请说明
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>权限名称</TableCell>
              <TableCell>用途说明</TableCell>
              <TableCell>是否可选</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>位置（始终允许）</TableCell>
              <TableCell>后台持续记录 GPS 轨迹</TableCell>
              <TableCell>是（关闭后无法记录完整轨迹）</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>相机</TableCell>
              <TableCell>拍摄照片或视频</TableCell>
              <TableCell>是</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>存储（媒体访问）</TableCell>
              <TableCell>保存/读取带位置的媒体文件</TableCell>
              <TableCell>是</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>麦克风</TableCell>
              <TableCell>录制视频时采集音频</TableCell>
              <TableCell>是（仅录像时请求）</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          三、我们如何保护您的个人信息
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="所有数据仅存储于设备本地私有目录" />
          </ListItem>
          <ListItem>
            <ListItemText primary="绝不将您的轨迹、照片、位置用于用户画像或出售" />
          </ListItem>
          <ListItem>
            <ListItemText primary="承诺不主动收集未成年人信息" />
          </ListItem>
        </List>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          四、您的权利
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="访问、删除本地轨迹与媒体数据" />
          </ListItem>
          <ListItem>
            <ListItemText primary="随时撤回系统权限" />
          </ListItem>
          <ListItem>
            <ListItemText primary="卸载应用以彻底清除数据" />
          </ListItem>
          <ListItem>
            <ListItemText primary="通过邮箱联系我们行使权利" />
          </ListItem>
        </List>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          五、声明更新
        </Typography>
        <Typography paragraph>我们可能适时修订本声明。更新后将通过应用内提示告知您。</Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight="medium"
          sx={{ mt: 3 }}
          gutterBottom
        >
          六、联系我们
        </Typography>
        <Typography paragraph>
          <strong>邮箱</strong>：2954060395@qq.com
        </Typography>
      </Paper>
    </Container>
  );
}
